// extracted by mini-css-extract-plugin
export var rangeWrapper = "RadialGaugeAdjustDegrees-module--range-wrapper--o9dmt";